export default "__VITE_ASSET__DHxVIUFU__"